import { render, staticRenderFns } from "./PostView.vue?vue&type=template&id=4e314e04&scoped=true"
import script from "./PostView.vue?vue&type=script&lang=js"
export * from "./PostView.vue?vue&type=script&lang=js"
import style0 from "./PostView.vue?vue&type=style&index=0&id=4e314e04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e314e04",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Calendar: require('/home/node/app/assets/icons/calendar.vue').default,User: require('/home/node/app/assets/icons/user.vue').default,FacebookCircle: require('/home/node/app/assets/icons/facebook-circle.vue').default,Twitter: require('/home/node/app/assets/icons/twitter.vue').default,UiPost: require('/home/node/app/components/ui/uiPost.vue').default,ControllerPost: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/controllers/ControllerPost.js').default})
